import React, { useEffect, useState } from 'react'
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Grid2 from '@mui/material/Unstable_Grid2';
import { Box, Button, FormControl, InputLabel, MenuItem, Select, TextField, inputClasses, inputLabelClasses } from '@mui/material';
import { Col, Row } from 'react-bootstrap';
import Home from '../home/Home';
import FundRqst_service from '../../Services/FundRqst_service';
import Snackbar from '../Snacbar'
import { getUserId } from '../Utils/Common';
import FileSaver from 'file-saver';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { useNavigate } from "react-router";
import { ToggleButton } from '@mui/material';

const CssTextField = styled(TextField)(`
  .${inputClasses.root} {
    height:35px;
  }
  .${inputLabelClasses.root} {
    font-family: Times New Roman;
    font-weight:bold;
    &.${inputLabelClasses.focused} {
      color: primary;
    }
  }
`);
const Csscontrol = styled(FormControl)({
    '& .MuiOutlinedInput-root': {
        '& fieldset': {
        }
    },
});
const Item = styled(Paper)(({ theme }) => ({
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
    backgroundColor: 'white',
    height: '100%',
    border: '1px solid black'
}));
const Item1 = styled(Paper)(({ theme }) => ({
    ...theme.typography.body2,
    padding: theme.spacing(1),
    // textAlign: 'center',
    color: theme.palette.text.secondary,
    backgroundColor: 'white',
    height: '100%',
    border: '1px solid black'
}));
const Item2 = styled(Paper)(({ theme }) => ({
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'right',
    color: theme.palette.text.secondary,
    backgroundColor: 'white',
    height: '100%',
    border: '1px solid black'
}));

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        color: theme.palette.common.black,
        backgroundColor: 'rgb(61, 195, 177)',
        padding: theme.spacing(0.5),
        fontFamily: 'Times New Roman',
        fontWeight: 'bold',
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
        fontFamily: 'Times New Roman',

    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: 'white',
    },
}));

function FundAudit() {
    ///hidden
    const [designHidden, setdesignHidden] = useState(true);
    const [tablehidden, settablehidden] = useState(true);
    const [VendorHidden, SetVendorHidden] = useState(true);
    const [searchbtnhidden, setsearchbtnhidden] = useState(true);
    const [JobHidden, SetJobHidden] = useState(false);
    //disable
    const [auditdis, setauditdis] = useState(true)
    const [updatedis, setupdatedis] = useState(true)
    const [non_auditdis, setnon_auditdis] = useState(true)
    const [uploaddis, setuploaddis] = useState(true)
    const [dwnlddis, setdwnlddis] = useState(true)
    //
    const [currentfile, setcurrentfile] = useState(undefined)
    const [message, setMessage] = useState('');
    const [open, setOpen] = useState(false);
    const [severit, setseverit] = useState('');
    const [status, setstatus] = useState('')
    const [fundstatusdrp, setfundstatusdrp] = useState([]);
    const [Vendordrp, setVendordrp] = useState([]);
    const [PaymentModedrp, setPaymentModedrp] = useState([]);

    const [imgUpload, setimgUpload] = useState(false);

    //setdetails
    const [auditDetails, setauditDetails] = useState([])
    const [auditDetails2, setauditDetails2] = useState([])
    const [auditDetails3, setauditDetails3] = useState([])
    const [auditDetails4, setauditDetails4] = useState([])
    const [auditDetails5, setauditDetails5] = useState([])
    const [FilteredDetails, setFilteredDetails] = useState([])
    const [FilteredDetails2, setFilteredDetails2] = useState([])
    // const [paymentcopydetails, setpaymentcopydetails] = useState([])
    // ///processing
    // const [auditProcs, setauditProcs] = useState(false)
    // const [updateProcs, setupdateProcs] = useState(false)
    // const [nonauditProcs, setnonauditProcs] = useState(false)
    // const [refreshProcs, setrefreshProcs] = useState(false)
    // const [dwnldRcpCopyProcs, setdwnldRcpCopyProcs] = useState(false)
    // const [uplRcpCopyProcs, setuplRcpCopyProcs] = useState(false)

    const [values, setvalues] = useState({
        cmid: '',
        purpose_pmtid: '',
        purpose_reqpurid: '',
        purposeSummary_id: '',

        jobNo: '',
        fundSts: '',
        vendortype: '',
        Audit_amt: '',
        Audit_PyMd: '',
        auditRemarks: '',
        ///
        Reqamt: '',
        Aprvlamt: '',
        FirstLvlamt: '',
        secLvlamt: '',
        allocatedamt: '',
        releaseamt: '',
    })

    const fundStsonChange = (e) => {
        if (e.target.value === 'JOB') {
            setstatus(1)
        } else if (e.target.value === 'VENDOR') {
            setstatus(2)
        } else if (e.target.value === 'MISCELLANEOUS') {
            setstatus(3)
        } else if (e.target.value === 'CLIENT') {
            setstatus(4)
        }
        //
        setvalues({
            ...values, allocatedamt: '', Aprvlamt: '', Audit_amt: '', Audit_PyMd: '', auditRemarks: '', cmid: '', FirstLvlamt: '', fundSts: e.target.value,
            jobNo: '', purpose_pmtid: '', purpose_reqpurid: '', purposeSummary_id: '', releaseamt: '', Reqamt: '', secLvlamt: '', vendortype: ''
        })

        setFilteredDetails([])
        setFilteredDetails2([])
        setauditDetails([])
        setauditDetails2([])
        setauditDetails3([])
        setauditDetails4([])
        setauditDetails5([])

        var consignmentNumber = '';
        if (e.target.value === 'JOB') {
            if (values.jobNo === '') {
                consignmentNumber = '-1';
            } else {
                consignmentNumber = values.jobNo;
            }
        }
        else if (e.target.value !== 'JOB') {
            if (values.vendortype === '') {
                consignmentNumber = '-1';
            } else {
                consignmentNumber = values.vendortype;
            }
        }

        FundRqst_service.getPaymentDetails_non_job_no_new(consignmentNumber, '8', e.target.value).then(res => { setauditDetails(res.data); setFilteredDetails(res.data) });

        FundRqst_service.getPaymentDetails_Job_no_new(consignmentNumber, '8', e.target.value).then(res => { setauditDetails4(res.data); setFilteredDetails2(res.data) })

        FundRqst_service.getBillPaymentType().then(res => { setPaymentModedrp(res.data); });

        if (e.target.value === 'JOB') {
            SetVendorHidden(true)
            SetJobHidden(false)
            setdesignHidden(false)
            settablehidden(false)
            setsearchbtnhidden(false)
        }
        else if (e.target.value === 'VENDOR' || e.target.value === 'MISCELLANEOUS' || e.target.value === 'CLIENT') {
            FundRqst_service.getVendorType(e.target.value).then(res => {
                setVendordrp(res.data)
            });
            SetVendorHidden(false)
            SetJobHidden(true)
            setdesignHidden(false)
            settablehidden(false)
            setsearchbtnhidden(true)
        }
        else if (e.target.value === "") {
            SetVendorHidden(true)
            SetJobHidden(false)
            setdesignHidden(true)
            settablehidden(true)
            setsearchbtnhidden(false)
        }
    }

    const jobNoonChange = (e) => {
        setvalues({ ...values, jobNo: e.target.value })
    }
    const vendorTypeonChange = (e) => {
        setvalues({ ...values, vendortype: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, '') });
        let details = { ip_consignmentId: e.target.value, status: '8', ip_fundStatus: values.fundSts }

        FundRqst_service.getPaymentDetails_non_job_no_new(details).then(res => { setauditDetails(res.data); setFilteredDetails(res.data) });

        let details2 = { ip_consignmentId: e.target.value, status: '8', ip_fundStatus: values.fundSts }
        FundRqst_service.getPaymentDetails_Job_no_new(details2).then(res => { setauditDetails4(res.data); setFilteredDetails2(res.data) })
    }
    const Audit_amtonChange = (e) => {
        setvalues({ ...values, Audit_amt: e.target.value })
    }
    const Audit_PyMdonChange = (e) => {
        setvalues({ ...values, Audit_PyMd: e.target.value })
    }
    const auditRemarksonChange = (e) => {
        setvalues({ ...values, auditRemarks: e.target.value })
    }
    ///
    const resetalloperation = () => {
        setvalues({
            ...values, cmid: '', purpose_pmtid: '', purpose_reqpurid: '', purposeSummary_id: '', Reqamt: '', Aprvlamt: '', FirstLvlamt: '', secLvlamt: '',
            allocatedamt: '', releaseamt: '', jobNo: '', Audit_amt: '', Audit_PyMd: '', auditRemarks: '',
        })
        setFilteredDetails([])
        setFilteredDetails2([])
        setauditDetails([]);
        setauditDetails2([]);
        setauditDetails3([]);
        setauditDetails4([]);
        setauditDetails5([]);
        setauditdis(true)
        setupdatedis(true)
        setnon_auditdis(true)
        setuploaddis(true)
        setdwnlddis(true)
        Getpaymentjob_nonjob_no();
    }
    ///
    const validation = () => {
        if (values.Audit_amt !== '') {
            if (values.Audit_PyMd !== '') {
                if (values.auditRemarks !== '') {
                    return true;
                } else {
                    setMessage('Please Enter the Audit-Remarks')
                    setseverit('warning')
                    setOpen(true)
                    document.getElementById('auditRmks').focus();
                }

            } else {
                setMessage('Please Select Payment Mode')
                setseverit('warning')
                setOpen(true)
                document.getElementById('payid').focus();
            }

        } else {
            setMessage('Please Enter Payment Audit Amount')
            setseverit('warning')
            setOpen(true)
            document.getElementById('auditamt').focus();
        }
        return false;
    }
    //jobsearch=================>
    const searchBtn = () => {
        setauditdis(true)
        setupdatedis(true)
        setnon_auditdis(true)
        setuploaddis(true)
        setdwnlddis(true)
        setvalues({
            ...values, Reqamt: '', Aprvlamt: '', FirstLvlamt: '', secLvlamt: '', allocatedamt: '', Release_amt: '', Audit_amt: '', Audit_PyMd: '', auditRemarks: '',
            cmid: '', purpose_pmtid: '', purpose_reqpurid: '',
        })
        setauditDetails2([]);
        setauditDetails3([]);
        Getpaymentjob_nonjob_no();
    }
    //
    const fundstsName = () => {
        if (status === 1) {
            return 'Job No';
        }
        else if (status === 2) {
            return 'VENDOR';
        }
        else if (status === 3) {
            return 'MISCELLANEOUS';
        }
        else if (status === 4) {
            return 'CLIENT';
        }
    }

    // Functions...
    ////getfundstatues=======>
    const FundStatusDropdown = async () => {
        FundRqst_service.getFundStatus().then(res => {
            setfundstatusdrp(res.data)
        })
    }
    ///
    const [selected, setSelected] = useState([]);
    const [selected1, setSelected1] = useState([]);
    ///table1click
    const getnonpurpose = (trns) => {
        const selectedIndex = selected.indexOf(trns.consignment_No);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = (selected, trns.consignment_No);
        }
        setSelected(newSelected);
        setauditDetails2([])
        setauditDetails5([])
        setauditdis(true)
        setupdatedis(true)
        setnon_auditdis(true)
        setuploaddis(true)
        setdwnlddis(true)
        setvalues({
            ...values, cmid: trns.consignment_id, Reqamt: '', Aprvlamt: '', FirstLvlamt: '', secLvlamt: '', allocatedamt: '', Audit_PyMd: '',
            Audit_amt: '', releaseamt: '', auditRemarks: '', purpose_pmtid: '', purpose_reqpurid: '', jobNo: trns.consignment_No
        })
        setauditDetails3([]);
        FundRqst_service.get_a_payment_details_request_purpose_v1(trns.consignment_id, '15', values.fundSts).then(res => {
            setauditDetails2(res.data);
        })

        FundRqst_service.get_a_payment_summary_details(trns.consignment_id, values.fundSts).then(res => {
            setauditDetails5(res.data);
        })
    }
    const isSelected = (name) => selected.indexOf(name) !== -1;
    ///table2click
    const nonverifypurpose = (trns) => {
        const selectedIndex = selected1.indexOf(trns.release_amount);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = (selected1, trns.release_amount);
        }
        setSelected1(newSelected);
        setauditDetails3([]);
        setauditdis(false)
        setupdatedis(true)
        setnon_auditdis(true)
        setuploaddis(false)
        setdwnlddis(false)
        getpaymentdetailsAssign(trns.payments_id, trns.request_purpose, 1)

        // let details = { cmId: values.cmid, reqPurpose: trns.request_purpose, status: '1' }

    }
    const isNonReqItemSelected = (name) => selected1.indexOf(name) !== -1;
    //
    ///table3click
    const verifypurpose = (trns) => {
        const selectedIndex = selected1.indexOf(trns.release_amount);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = (selected1, trns.release_amount);
        }
        setSelected1(newSelected);
        setauditDetails2([])
        setauditdis(true)
        setupdatedis(false)
        setnon_auditdis(false)
        setuploaddis(false)
        setdwnlddis(false)
        getpaymentdetailsAssign(trns.payments_id, trns.request_purpose, 2)

    }
    const isReqItemSelected = (name) => selected1.indexOf(name) !== -1;
    ///table4click
    const getpurpose = (trns) => {
        const selectedIndex = selected.indexOf(trns.consignment_No);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = (selected, trns.consignment_No);
        }
        setSelected(newSelected);

        setauditDetails3([])
        setauditDetails5([])
        setauditdis(true)
        setupdatedis(true)
        setnon_auditdis(true)
        setuploaddis(true)
        setdwnlddis(true)
        setvalues({
            ...values, cmid: trns.consignment_id, Reqamt: '', Aprvlamt: '', FirstLvlamt: '', secLvlamt: '', allocatedamt: '', Allocated_PyMd: '',
            releaseamt: '', Audit_amt: '', auditRemarks: '', purpose_pmtid: '', purpose_reqpurid: '', Audit_PyMd: '', jobNo: '', vendortype: '',
        })
        setauditDetails2([]);
        FundRqst_service.get_a_payment_details_request_purpose_v1(trns.consignment_id, '16', values.fundSts).then(res => {
            setauditDetails3(res.data);
        })

        FundRqst_service.get_a_payment_summary_details(trns.consignment_id, values.fundSts).then(res => {
            setauditDetails5(res.data);
        })

    }
    const isReqjobSelected = (name) => selected.indexOf(name) !== -1;
    ////
    const Getpaymentjob_nonjob_no = () => {
        var consignmentNumber = '';
        if (values.fundSts === 'JOB') {
            if (values.jobNo === '') {
                consignmentNumber = '-1';
            } else {
                consignmentNumber = values.jobNo;
            }
        }
        else if (values.fundSts !== 'JOB') {
            if (values.vendortype === '') {
                consignmentNumber = '-1';
            } else {
                consignmentNumber = values.vendortype;
            }
        }
        FundRqst_service.getPaymentDetails_non_job_no_new(consignmentNumber, '8', values.fundSts).then(res => { setauditDetails(res.data); setFilteredDetails(res.data) });

        FundRqst_service.getPaymentDetails_Job_no_new(consignmentNumber, '8', values.fundSts).then(res => { setauditDetails4(res.data); setFilteredDetails2(res.data) })

    }
    ///assignFundRelease
    const getpaymentdetailsAssign = (payid, reqid, val) => {
        // let details = { ip_payments_id: payid }
        FundRqst_service.get_o_ac_payment_estimated(payid).then(res => {
            const data = res.data;
            const details = data.map((trns) => trns);
            var txt_amount = '';
            if (val === 1) {
                txt_amount = details[0].release_amount
            } else {
                txt_amount = details[0].audit_amount
            }
            setvalues({
                ...values, purpose_pmtid: payid, purpose_reqpurid: reqid, Reqamt: details[0].request_amount, Aprvlamt: details[0].approval_amount, FirstLvlamt: details[0].first_level_amount, secLvlamt: details[0].second_level_amount,
                allocatedamt: details[0].allocated_amount, releaseamt: details[0].release_amount, Audit_amt: txt_amount, Audit_PyMd: details[0].audit_mode, auditRemarks: details[0].audit_remarks
            })
        }).catch(error => {
            setMessage(error.message);
            setseverit('error');
            setOpen(true);
        })
    }
    const [copyFormat, setcopyFormat] = useState('')
    //onClick functions...
    const auditjobOnclick = () => {
        if (validation() === true) {
            var recipetCopy = currentfile;
            var recipetCopyFile = ''; var ip_payment_receipt_copy = null;
            if (recipetCopy === null || !recipetCopy) {

            } else {
                if (copyFormat === 'PNG') {
                    recipetCopyFile = recipetCopy.split("data:image/png;base64,");
                } else if (copyFormat === 'JPG') {
                    recipetCopyFile = recipetCopy.split("data:image/jpeg;base64,");
                }
                else if (copyFormat === 'PDF') {
                    recipetCopyFile = recipetCopy.split("data:pdf;base64,");
                }
                else {
                    recipetCopyFile = recipetCopy.split("data:image/jpeg;base64,");
                }

                if (!recipetCopyFile[1] || recipetCopyFile[1] === "undefined") {
                    ip_payment_receipt_copy = null;
                } else {
                    ip_payment_receipt_copy = recipetCopyFile[1];
                }
            }
            console.log('valuesss=>' + JSON.stringify(values.Audit_PyMd, values.auditRemarks, values.Audit_amt))
            let details = {
                payments_id: values.purpose_pmtid, request_amount: null, request_purpose: null, request_paid_to: null, request_date: null, req_by: null, approval_amount: null,
                approval_date: null, approved_by: null, first_level_amount: null, first_level_date: null, first_level_by: null, second_level_amount: null, second_level_date: null,
                second_level_by: null, allocated_amount: null, allocated_mode: null, allocated_voucher_no: null, allocated_voucher_type: null,
                allocated_vocher_coby: null, allocated_printed_type: null, allocated_date: null, allocatedBy: null, ip_status: '8', ip_remarks: null, ip_refNo: null,
                ip_bankName: null, ip_accountNo: null, ip_ifsc: null, ip_benName: null, ip_gstinPayee: null, ip_fundStatus: null, ip_refund: null, audit_amount: values.Audit_amt,
                audit_mode: values.Audit_PyMd, audit_remarks: values.auditRemarks, audit_by: getUserId(), ip_payment_receipt_copy: ip_payment_receipt_copy,
            }
            FundRqst_service.update_o_ac_payment_estimated(details).then(res => {
                const message = res.data.message;
                if (message.toString() === 'SUCCESS') {
                    setMessage('Audited Successfully');
                    setseverit('success');
                    setOpen(true);
                    // resetalloperation();
                    setvalues({
                        ...values, cmid: '', purpose_pmtid: '', purpose_reqpurid: '', purposeSummary_id: '', Reqamt: '', Aprvlamt: '', FirstLvlamt: '', secLvlamt: '',
                        allocatedamt: '', releaseamt: '', jobNo: '', Audit_amt: '', Audit_PyMd: '', auditRemarks: '',
                    })
                    setFilteredDetails([])
                    setFilteredDetails2([])
                    setauditDetails([]);
                    setauditDetails2([]);
                    setauditDetails3([]);
                    setauditDetails4([]);
                    setauditDetails5([]);
                    setauditdis(true)
                    setupdatedis(true)
                    setnon_auditdis(true)
                    setuploaddis(true)
                    setdwnlddis(true)
                    // Getpaymentjob_nonjob_no();
                    var consignmentNumber = '';
                    if (values.fundSts === 'JOB') {
                        consignmentNumber = '-1';
                    }
                    else if (values.fundSts !== 'JOB') {
                        if (values.vendortype === '') {
                            consignmentNumber = '-1';
                        } else {
                            consignmentNumber = values.vendortype;
                        }
                    }
                    FundRqst_service.getPaymentDetails_non_job_no_new(consignmentNumber, '8', values.fundSts).then(res => { setauditDetails(res.data); setFilteredDetails(res.data) });

                    FundRqst_service.getPaymentDetails_Job_no_new(consignmentNumber, '8', values.fundSts).then(res => { setauditDetails4(res.data); setFilteredDetails2(res.data) })
                } else {
                    setMessage('AUdit Failed ' + message.toString())
                    setseverit('error')
                    setOpen(true)
                }
            }).catch(error => {
                setMessage('Audit Failed ' + error.message);
                setseverit('error');
                setOpen(true);
            })
        }
    }
    const NonAllocatedBtn = () => {
        let details = {
            consignment_id: values.cmid, payments_id: values.purpose_pmtid, ip_status: '8',
            user_id: getUserId(), ip_fundStatus: values.fundSts
        }
        FundRqst_service.update_a_payment_details_status_new_v1(details).then(res => {
            const message = res.data.message;
            if (message.toString() === 'SUCCESS') {
                setMessage('Non Audited Successfully');
                setseverit('success');
                setOpen(true);
                resetalloperation();
            } else {
                setMessage('Non Audit Failed ,Warning ..!!' + message.toString());
                setseverit('error');
                setOpen(true);
                document.getElementById('auditamt').focus();
            }
        }).catch(error => {
            setMessage('Non-Audit Failed ' + error.message);
            setseverit('error');
            setOpen(true);
        })
    }
    const RefreshClickBtn = () => {
        setvalues({
            ...values, cmid: '', purpose_pmtid: '', purpose_reqpurid: '', fundSts: 'JOB', Reqamt: '', Aprvlamt: '', FirstLvlamt: '', secLvlamt: '', allocatedamt: '',
            Release_amt: '', Audit_amt: '', Audit_PyMd: '', auditRemarks: '', jobNo: '', purposeSummary_id: '', releaseamt: '', vendortype: ''
        })
        setauditDetails([])
        setauditDetails2([])
        setauditDetails3([])
        setauditDetails4([])
        setauditDetails5([])
        setFilteredDetails([])
        setFilteredDetails2([])
        setauditdis(true)
        setupdatedis(true)
        setnon_auditdis(true)
        setuploaddis(true)
        setdwnlddis(true)
        Getpaymentjob_nonjob_no()
        document.getElementById('fundsts').focus();
    }
    ////
    const uploadrqstcopy = () => {
        if (values.Audit_amt === '' || !values.Audit_amt) {
            setMessage("Please Select Type Audit Amount............");
            setseverit('warning');
            setOpen(true);
            setimgUpload(false);
        }
        else {
            setimgUpload(true);
        }
    }
    const selectimgUpload = (event) => {
        const file = event.target.files[0];
        const imageMimeTypepng = /image\/(png)/i;
        const imageMimeTypejpg = /image\/(jpg)/i;
        const imageMimeTypeJpeg = /image\/(jpeg)/i;
        const imageMimeTypePdf = /(pdf)/i;
        const reader = new FileReader();
        reader.onload = () => {
            if (file.type.match(imageMimeTypepng)) {
                setcopyFormat('PNG')
            } else if (file.type.match(imageMimeTypejpg)) {
                setcopyFormat('JPG')
            }
            else if (file.type.match(imageMimeTypeJpeg)) {
                setcopyFormat('JPEG')
            }
            else if (file.type.match(imageMimeTypePdf)) {
                setcopyFormat('PDF')
            }
            setcurrentfile(reader.result);

        }
        reader.readAsDataURL(event.target.files[0])
    }
    const saveimage = () => {
        FundRqst_service.get_o_ac_payment_receipt_copy(values.purpose_pmtid).then(res => {
            const data = res.data;
            var details = data.map((trans) => trans);
            // FileSaver.saveAs(`data:image/jpeg;base64,${details[0].ip_payment_receipt_copy}`, values.jobNo + ".jpeg");
            const filedata = details[0].toString()
            const formates = filedata.split('/9j/4');
            //    console.log('ggg '+JSON.stringify(formates))
            if (formates[0] === '') {
                FileSaver.saveAs(`data:image/jpg;base64,${details[0].toString()}`, values.purpose_pmtid + ".jpg");
            } else {
                const Pngformates = filedata.split('iVBORw0KGg');
                if (Pngformates[0] === '') {
                    FileSaver.saveAs(`data:image/jpg;base64,${details[0].toString()}`, values.purpose_pmtid + ".jpg");
                } else {
                    FileSaver.saveAs(`data:application/pdf;base64,${details[0].toString()}`, values.purpose_pmtid + ".pdf");
                }
            }
        })
    }
    const handleClose = () => {
        setOpen(false)
    }
    const fundSrch = () => {
        return <input style={{ width: '80px', textAlign: 'center', fontSize: '12px' }} placeholder="Search"
            onChange={(e) => { fundOnchange(e.target.value) }} />
    }
    const fundOnchange = (searchedVal) => {
        const filteredvalue = auditDetails.filter((trns) => {
            return trns.consignment_No.toString().toLowerCase().includes(searchedVal.toLowerCase())
        })
        if (filteredvalue.length > 1) {
            setFilteredDetails(auditDetails)
        } else {
            setFilteredDetails(filteredvalue)
        }
    }
    const fundSrch2 = () => {
        return <input style={{ width: '80px', textAlign: 'center', fontSize: '12px' }} placeholder="Search"
            onChange={(e) => { fund2Onchange(e.target.value) }} />
    }
    const fund2Onchange = (searchedVal) => {
        const filteredvalue = auditDetails4.filter((trns) => {
            return trns.consignment_No.toString().toLowerCase().includes(searchedVal.toLowerCase())
        })
        if (filteredvalue.length > 1) {
            setFilteredDetails2(auditDetails4)
        } else {
            setFilteredDetails2(filteredvalue)
        }
    }
    useEffect(() => {
        FundStatusDropdown();
    }, []);
    const navigate = useNavigate();
    const BackButton = () => {
        navigate('/fund_rcptCpy');
    }
    const ForwardButton = () => {
        navigate('/fundrefund');
    }
    return (
        <div>
            <Home />
            <Snackbar open={open} message={message} severity={severit} onClose={handleClose} />
            <div style={{ paddingLeft: '80px', transition: '1s', transitionDelay: 'revert-layer' }}>
                <Row>
                    <Col xs={1}><ToggleButton onClick={BackButton} className='headerstyleStrt' size="small">
                        <ArrowBackIosIcon fontSize="small" style={{ fontSize: '16px', marginLeft: '5px', color: 'red', fontWeight: 'bold' }} /> </ToggleButton></Col>
                    <Col xs={10}></Col>
                    <Col xs={1} style={{ textAlign: 'end' }}> <ToggleButton onClick={ForwardButton} className='headerstyleEND' size="small">
                        <ArrowForwardIosIcon fontSize="small" style={{ fontSize: '16px', color: 'red', fontWeight: 'bold' }} /> </ToggleButton>
                    </Col>
                </Row>
                <Grid2 container>
                    <Box style={{ width: '11.5%' }}>
                        <Item1>
                            {/* <ToggleButton onClick={BackButton} className='headerstyleStrt' size="small" >
                                <ArrowBackIosIcon fontSize='small' style={{ fontSize: '16px', marginLeft: '5px' }} /> </ToggleButton> */}
                            <lable style={{ fontFamily: 'Times New Roman', fontSize: '10px', fontWeight: 'bold', color: 'red', marginLeft: '2px' }}>Non Audit Job</lable>
                            <TableContainer sx={{ maxHeight: 350 }} className='scrollbarPrime'>
                                <Table stickyHeader className='table table-bordered'>
                                    <TableHead>
                                        <StyledTableRow>
                                            <StyledTableCell style={{ textAlign: 'center' }}>`{fundstsName()}</StyledTableCell>
                                        </StyledTableRow>
                                        <StyledTableRow >
                                            <StyledTableCell style={{ textAlign: 'center' }}>{fundSrch()}</StyledTableCell>
                                        </StyledTableRow>
                                    </TableHead>
                                    <TableBody>
                                        {FilteredDetails.map((trns) => {
                                            const isItemSelected = isSelected(trns.consignment_No);
                                            return (
                                                <TableRow hover selected={isItemSelected} key={trns.consignment_No} onClick={() => getnonpurpose(trns)}>
                                                    <StyledTableCell style={{ textAlign: 'center', color: 'darkblue' }}>{trns.consignment_No}</StyledTableCell>
                                                </TableRow>
                                            )
                                        })}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Item1>
                    </Box>
                    <Box style={{ width: '20%' }}>
                        <Item>
                            <lable style={{ fontFamily: 'Times New Roman', fontSize: '10px', fontWeight: 'bold', color: 'red' }}>Non Audit Purpose</lable>
                            <TableContainer sx={{ maxHeight: 350 }} className='scrollbarPrime'>
                                <Table stickyHeader className='table table-bordered'>
                                    <TableHead>
                                        <StyledTableRow>
                                            <StyledTableCell style={{ width: '10px', textAlign: 'center' }}>Sl</StyledTableCell>
                                            <StyledTableCell style={{ textAlign: 'center', width: '100px' }}>Description</StyledTableCell>
                                            <StyledTableCell style={{ width: '40px', textAlign: 'center' }}>Amount</StyledTableCell>
                                        </StyledTableRow>
                                    </TableHead>
                                    <TableBody>
                                        {auditDetails2.map((trns) => {
                                            const isItemSelected = isNonReqItemSelected(trns.release_amount);
                                            return (
                                                <TableRow hover selected={isItemSelected} key={trns.release_amount} onClick={() => nonverifypurpose(trns)}>
                                                    <StyledTableCell style={{ color: 'darkblue' }}>{trns.serialnumber}</StyledTableCell>
                                                    <StyledTableCell style={{ color: 'darkblue' }}>{trns.request_purpose}</StyledTableCell>
                                                    <StyledTableCell style={{ color: 'darkblue' }}>{trns.release_amount}</StyledTableCell>
                                                </TableRow>
                                            )
                                        })}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Item>
                    </Box>
                    <Box style={{ width: '37%' }}>
                        <Item>
                            <div style={{ fontFamily: 'Times New Roman', color: 'red', fontWeight: 'bold', fontSize: '20px', marginTop: '2%', marginBottom: '2%' }}><center>FUND AUDIT</center></div>
                            <Csscontrol fullWidth size='small' style={{ width: '35%', marginTop: '2%' }}>
                                <InputLabel id="demo-select-small" style={{ fontFamily: 'Times New Roman', fontWeight: 'bold' }}>Fund Status</InputLabel>
                                <Select InputLabelProps={{ shrink: true, }} label="Fund Statusss" id='fundsts' style={{ fontSize: '13px', fontFamily: 'Times New Roman', color: 'black', fontWeight: 'bold', textAlign: 'center', }} onChange={fundStsonChange} value={values.fundSts}>
                                    <MenuItem></MenuItem>
                                    {fundstatusdrp.map(status => (
                                        <MenuItem value={status.requestStatus}>{status.requestStatus}</MenuItem>
                                    ))}
                                </Select>
                            </Csscontrol>

                            <CssTextField hidden={JobHidden} size='small' style={{ width: '35%', marginLeft: '2%', marginTop: '2%' }} onChange={jobNoonChange} value={values.jobNo} label="Job No" variant="outlined"
                                sx={{ input: { fontFamily: 'Times New Roman', color: 'black', fontWeight: 'bold', textAlign: 'center', fontSize: '13px' } }} />

                            <Button hidden={searchbtnhidden} size='small' variant="contained" color="primary" style={{ fontFamily: 'Times New Roman', marginTop: '2%', marginLeft: '1%' }} onClick={searchBtn}>Search</Button>

                            <Csscontrol hidden={VendorHidden} fullWidth size='small' style={{ width: '35%', marginLeft: '2%', marginTop: '2%' }} InputLabelProps={{ shrink: true, }}>
                                <InputLabel id="demo-select-small" style={{ fontFamily: 'Times New Roman', fontWeight: 'bold' }}>Vendor Type</InputLabel>
                                <Select label="Vendor Typeeee" native style={{ fontSize: '13px', fontFamily: 'Times New Roman', color: 'black', fontWeight: 'bold', textAlign: 'center', }}
                                    onChange={vendorTypeonChange} value={values.vendortype}>
                                    <option></option>
                                    {Vendordrp.map(trns => (
                                        <option value={trns.reqPaidTo}>{trns.reqPaidTo}</option>
                                    ))}
                                </Select>
                            </Csscontrol>

                            <div hidden={designHidden}>
                                <Row className='mt-4'>
                                    <Col>
                                        <InputLabel style={{ fontFamily: 'Times New Roman', fontSize: '12px', fontWeight: 'bold', color: 'black' }}>Request Amt :</InputLabel>
                                    </Col>
                                    <Col style={{ fontFamily: 'Times New Roman', fontSize: '12px', fontWeight: 'bold', color: 'Red' }}>{values.Reqamt}</Col>
                                    <Col>
                                        <InputLabel style={{ fontFamily: 'Times New Roman', fontSize: '12px', fontWeight: 'bold', color: 'black' }}>Approval Amt :</InputLabel>
                                    </Col>
                                    <Col style={{ fontFamily: 'Times New Roman', fontSize: '12px', fontWeight: 'bold', color: 'Red' }}>{values.Aprvlamt}</Col>

                                </Row>
                                <Row>
                                    <Col xs={3}>
                                        <InputLabel style={{ fontFamily: 'Times New Roman', fontSize: '12px', fontWeight: 'bold', color: 'black' }}>1stLvlVerifAmt :</InputLabel>
                                    </Col>
                                    <Col xs={3} style={{ fontFamily: 'Times New Roman', fontSize: '12px', fontWeight: 'bold', color: 'Red' }}>{values.FirstLvlamt}</Col>
                                    <Col xs={3}>
                                        <InputLabel style={{ fontFamily: 'Times New Roman', fontSize: '12px', fontWeight: 'bold', color: 'black' }}>2ndLvlVerifAmt :</InputLabel>
                                    </Col>
                                    <Col xs={3} style={{ fontFamily: 'Times New Roman', fontSize: '12px', fontWeight: 'bold', color: 'Red' }}>{values.secLvlamt}</Col>
                                </Row>
                                <Row>
                                    <Col xs={3}><InputLabel style={{ fontSize: '12px', fontWeight: 'bold', color: 'black' }}>Allocated Amt :</InputLabel></Col>
                                    <Col xs={3} style={{ fontSize: '12px', fontWeight: 'bold', color: 'Red' }}>{values.allocatedamt}</Col>
                                    <Col xs={3}><InputLabel style={{ fontSize: '12px', fontWeight: 'bold', color: 'black' }}>Released Amt :</InputLabel></Col>
                                    <Col xs={3} style={{ fontSize: '12px', fontWeight: 'bold', color: 'Red' }}>{values.releaseamt}</Col>
                                </Row>
                                <Row className='mt-4'>
                                    <Col>
                                        <CssTextField size='small' id='auditamt' label="Audit Amount" variant="outlined" style={{ width: '49%' }} required
                                            sx={{ input: { fontFamily: 'Times New Roman', color: 'black', fontWeight: 'bold', textAlign: 'center', fontSize: '13px' } }} onChange={Audit_amtonChange} value={values.Audit_amt} />

                                        <Csscontrol fullWidth size='small' style={{ width: '49%', marginLeft: '1%' }} required>
                                            <InputLabel id="demo-select-small" style={{ fontFamily: 'Times New Roman', fontWeight: 'bold' }}>Payment Mode</InputLabel>
                                            <Select label="Payment Modeee" id='payid' style={{ fontSize: '13px', fontFamily: 'Times New Roman', color: 'black', fontWeight: 'bold', textAlign: 'center', }} InputLabelProps={{ shrink: true, }} native
                                                onChange={Audit_PyMdonChange} value={values.Audit_PyMd}>
                                                <option></option>
                                                {PaymentModedrp.map(trns => (
                                                    <option value={trns.paymentType}>{trns.paymentType}</option>
                                                ))}
                                            </Select>
                                        </Csscontrol>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <CssTextField size='small' label="Release Remarks" id='auditRmks' variant="outlined" style={{ width: '49%', marginLeft: '1%', marginTop: '2%' }}
                                            sx={{ input: { fontFamily: 'Times New Roman', color: 'black', fontWeight: 'bold', textAlign: 'center', fontSize: '13px' } }} onChange={auditRemarksonChange} value={values.auditRemarks} />
                                    </Col>
                                </Row>
                            </div>
                        </Item>
                    </Box>
                    <Box style={{ width: '20%' }}>
                        <Item>
                            <lable style={{ fontFamily: 'Times New Roman', fontSize: '10px', fontWeight: 'bold', color: 'red' }}>Audit Purpose</lable>
                            <TableContainer sx={{ maxHeight: 350 }} className='scrollbarPrime'>
                                <Table stickyHeader className='table table-bordered'>
                                    <TableHead>
                                        <StyledTableRow>
                                            <StyledTableCell style={{ width: '10px', textAlign: 'center' }}>Sl</StyledTableCell>
                                            <StyledTableCell style={{ textAlign: 'center' }} >Description</StyledTableCell>
                                            <StyledTableCell style={{ width: '40px', textAlign: 'center' }}>Amount</StyledTableCell>
                                        </StyledTableRow>
                                    </TableHead>
                                    <TableBody>
                                        {auditDetails3.map((trns) => {
                                            const isItemSelected = isReqItemSelected(trns.release_amount);
                                            return (
                                                <TableRow selected={isItemSelected} hover key={trns.release_amount} onClick={() => verifypurpose(trns)}>
                                                    <StyledTableCell style={{ color: 'darkblue' }}>{trns.serialnumber}</StyledTableCell>
                                                    <StyledTableCell style={{ color: 'darkblue' }}>{trns.request_purpose}</StyledTableCell>
                                                    <StyledTableCell style={{ color: 'darkblue' }}>{trns.release_amount}</StyledTableCell>
                                                </TableRow>
                                            )
                                        })}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Item>
                    </Box>
                    <Box style={{ width: '11.5%' }}>
                        <Item2>
                            <lable style={{ fontFamily: 'Times New Roman', fontSize: '10px', fontWeight: 'bold', color: 'red', marginRight: '10px' }}>Audit Job</lable>
                            {/* <ToggleButton onClick={ForwardButton} size="small" className='headerstyleEND'>
                                <ArrowForwardIosIcon fontSize="small" style={{ fontSize: '16px' }} /> </ToggleButton> */}
                            <TableContainer sx={{ maxHeight: 350 }} className='scrollbarPrime'>
                                <Table stickyHeader className='table table-bordered'>
                                    <TableHead>
                                        <StyledTableRow>
                                            <StyledTableCell style={{ textAlign: 'center' }}>`{fundstsName()}</StyledTableCell>
                                        </StyledTableRow>
                                        <StyledTableRow >
                                            <StyledTableCell style={{ textAlign: 'center' }}>{fundSrch2()}</StyledTableCell>
                                        </StyledTableRow>
                                    </TableHead>
                                    <TableBody>
                                        {FilteredDetails2.map((trns) => {
                                            const isItemSelected = isReqjobSelected(trns.consignment_No);
                                            return (
                                                <TableRow hover selected={isItemSelected} key={trns.consignment_No} onClick={() => getpurpose(trns)}>
                                                    <StyledTableCell style={{ textAlign: 'center', color: 'darkblue' }}>{trns.consignment_No}</StyledTableCell>
                                                </TableRow>
                                            )
                                        })}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Item2>
                    </Box>
                </Grid2>
                <center hidden={designHidden}><div className='mt-2 mb-1 form-inline'>
                    <Button size='small' style={{ fontFamily: 'Times New Roman' }} variant="contained" color="primary" className='mt-1' disabled={auditdis} onClick={auditjobOnclick} >AUDIT</Button>{' '}
                    <Button size='small' style={{ fontFamily: 'Times New Roman' }} variant="contained" className='mt-1' color="primary" disabled={updatedis} onClick={auditjobOnclick}>UPDATE</Button>{' '}
                    <Button size='small' style={{ fontFamily: 'Times New Roman' }} variant="contained" className='mt-1' color="primary" disabled={non_auditdis} onClick={NonAllocatedBtn}>NON AUDIT</Button>{' '}
                    {/* <Button size='small' variant="contained" className='mt-1' color="primary" disabled={uploaddis}>Upload Receipt copy</Button>{' '} */}
                    <label style={{ fontFamily: 'Times New Roman' }} onClick={uploadrqstcopy} disabled={uploaddis} className="btn btn-primary p-1 mt-1" >UPLOAD RECEPIT COPY'{imgUpload ?
                        <input type="file" accept='.pdf,.jpeg,.jpg' onChange={selectimgUpload} hidden /> : null}
                    </label>{' '}
                    <Button style={{ fontFamily: 'Times New Roman' }} size='small' variant="contained" className='mt-1' color="primary" disabled={dwnlddis} onClick={saveimage}>Download Recepit copy</Button>{' '}
                    <Button style={{ fontFamily: 'Times New Roman' }} size='small' variant="contained" className='mt-1' color="primary" onClick={RefreshClickBtn}>REFRESH</Button>{' '}
                </div></center>
                <Item hidden={tablehidden}>
                    <TableContainer sx={{ maxHeight: 215 }} className='scrollbarPrime'>
                        <Table stickyHeader className='table table-bordered'>
                            <TableHead>
                                <StyledTableRow>
                                    <StyledTableCell style={{ textAlign: 'center' }}>Sl</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>Description</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>RequestAmount</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }} >Request_Date</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>RequestRemarks</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>RequestBy</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>ApprovalAmount</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>ApprovalDate</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>ApprovalRemarks</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>ApprovalBy</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>1stLevelAmount</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>1stLevelDate</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>1stLevelRemarks</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>1stApprovedBy</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>2ndLevelAmount</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>2ndLevelDate</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>2ndLevelRemarks</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>2nd_ApprovedBy</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>AllocatedAmount</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>AllocatedDate</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>AllocatedRemarks</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>AllocatedBY</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>ReleaseAmmount</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>ReleaseDate</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>ReleaseRemarks</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>Release_BY</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>AuditedAmmount</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>AuditedDate</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>AuditedRemarks</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>AuditedBY</StyledTableCell>
                                </StyledTableRow>
                            </TableHead>
                            <TableBody>
                                {auditDetails5.map((trns) => (
                                    <StyledTableRow hover key={trns.reqPurpose}>
                                        <StyledTableCell style={{ textAlign: 'center' }}>{trns.serialnumber}</StyledTableCell>
                                        <StyledTableCell style={{ textAlign: 'center' }}>{trns.request_purpose}</StyledTableCell>
                                        <StyledTableCell style={{ textAlign: 'center' }}>{trns.request_amount}</StyledTableCell>
                                        <StyledTableCell style={{ textAlign: 'center' }}>{trns.request_date}</StyledTableCell>
                                        <StyledTableCell style={{ textAlign: 'center' }}>{trns.request_remarks}</StyledTableCell>
                                        <StyledTableCell style={{ textAlign: 'center' }}>{trns.req_by}</StyledTableCell>
                                        <StyledTableCell style={{ textAlign: 'center' }}>{trns.approval_amount}</StyledTableCell>
                                        <StyledTableCell style={{ textAlign: 'center' }}>{trns.approval_date}</StyledTableCell>
                                        <StyledTableCell style={{ textAlign: 'center' }}>{trns.approval_remarks}</StyledTableCell>
                                        <StyledTableCell style={{ textAlign: 'center' }}>{trns.approved_by}</StyledTableCell>
                                        <StyledTableCell style={{ textAlign: 'center' }}>{trns.first_level_amount}</StyledTableCell>
                                        <StyledTableCell style={{ textAlign: 'center' }}>{trns.first_level_date}</StyledTableCell>
                                        <StyledTableCell style={{ textAlign: 'center' }}>{trns.first_level_remarks}</StyledTableCell>
                                        <StyledTableCell style={{ textAlign: 'center' }}>{trns.first_level_by}</StyledTableCell>
                                        <StyledTableCell style={{ textAlign: 'center' }}>{trns.second_level_amount}</StyledTableCell>
                                        <StyledTableCell style={{ textAlign: 'center' }}>{trns.second_level_date}</StyledTableCell>
                                        <StyledTableCell style={{ textAlign: 'center' }}>{trns.second_level_remarks}</StyledTableCell>
                                        <StyledTableCell style={{ textAlign: 'center' }}>{trns.second_level_by}</StyledTableCell>
                                        <StyledTableCell style={{ textAlign: 'center' }}>{trns.allocated_amount}</StyledTableCell>
                                        <StyledTableCell style={{ textAlign: 'center' }}>{trns.allocated_date}</StyledTableCell>
                                        <StyledTableCell style={{ textAlign: 'center' }}>{trns.allocated_remarks}</StyledTableCell>
                                        <StyledTableCell style={{ textAlign: 'center' }}>{trns.allocated_by}</StyledTableCell>
                                        <StyledTableCell style={{ textAlign: 'center' }}>{trns.release_amount}</StyledTableCell>
                                        <StyledTableCell style={{ textAlign: 'center' }}>{trns.release_date}</StyledTableCell>
                                        <StyledTableCell style={{ textAlign: 'center' }}>{trns.release_remarks}</StyledTableCell>
                                        <StyledTableCell style={{ textAlign: 'center' }}>{trns.released_by}</StyledTableCell>
                                        <StyledTableCell style={{ textAlign: 'center' }}>{trns.audit_amount}</StyledTableCell>
                                        <StyledTableCell style={{ textAlign: 'center' }}>{trns.audit_date}</StyledTableCell>
                                        <StyledTableCell style={{ textAlign: 'center' }}>{trns.audit_remarks}</StyledTableCell>
                                        <StyledTableCell style={{ textAlign: 'center' }}>{trns.audit_by}</StyledTableCell>
                                    </StyledTableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Item>
            </div>
        </div>
    )
}

export default FundAudit